module.exports = __webpack_public_path__ + "static/lifelongBrotherhood-bce9e540143ac2c898397e7f5a4d0fbb.jpg";